import { render, staticRenderFns } from "./anggota_kelompok.vue?vue&type=template&id=17193280&"
import script from "./anggota_kelompok.vue?vue&type=script&lang=js&"
export * from "./anggota_kelompok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports